import { css } from "@emotion/css/dist/emotion-css.umd.min.js";

const colours = {
    blue: css`
        color: #00d;
    `,
    green: css`
        color: #0d0;
    `,
    cyan: css`
        color: #0dd;
    `,
    red: css`
        color: #d00;
    `,
    majenta: css`
        color: #d0d;
    `,
    orange: css`
        color: #fb0;
    `,
};

export const getColourClass = (colour: string): string => colours[colour];
